import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from 'react-oidc-context';
import { useOidcMessageHandler } from '../hooks/useOidcMessageHandler';
import AuthNavigator from './auth/AuthNavigator';
import { McpSessionProvider } from './McpSessionProvider';
import { ExcelMain } from './excel/ExcelMain';
const ExcelApp = () => {
    const { isAuthenticated } = useAuth();
    // Handle OIDC messages from auth popup
    useOidcMessageHandler();
    return (_jsx("div", { className: "h-full bg-white", children: isAuthenticated ? (_jsx(McpSessionProvider, { children: _jsx(ExcelMain, {}) })) : (_jsx(AuthNavigator, {})) }));
};
export default ExcelApp;
